import courtCaseRoute from './court-case.route'
import calendarRoute from './calendar.route'
import fileStoreRoute from './file-store.route'
import knowledgeBaseRoute from './knowledgebase.route'
import postRoute from './post.route'
import otherRoute from './other.route'
import specialistRoute from './specialist.route'
import admin from './admin.route'
import nowrap from './nowrap.route'
import page from './page.route'
import paymentOrderRoute from './payment-order.route'

import NotFound from '@/pages/common/NotFoundPage.vue'
const Home = () => import('@/pages/home/HomeLayout.vue')
const HomeContent = () => import('@/pages/home/HomeContent.vue')
const Lobby = () => import('@/pages/home/RoomLobby.vue')

const routes = [
  {
    path: '/',
    component: Home,
    alias: ['/home', '/index'],
    children: [
      {
        path: '',
        name: 'Home',
        component: HomeContent,
      }
    ]
  },
  {
    path: '/room/:roomName',
    name: 'Lobby',
    props: true,
    component: Lobby,
  },
  {
    path: '*', 
    component: NotFound
  },
  nowrap,
  courtCaseRoute,
  calendarRoute,
  postRoute,
  fileStoreRoute,
  knowledgeBaseRoute,
  otherRoute,
  specialistRoute,
  admin,
  page,
  paymentOrderRoute
]

export default routes
